import React from 'react';

import {ModuleController} from "../../../infrastructure/controllers/module-controller";
import {BaseMobxState} from "../../../infrastructure/mobx/base-mobx-state";
import {AppTerms} from "../../app/app-terms";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {OptionsStripe} from "../options-stripe/options-stripe";
import {UseTerms} from "../composers/composer-plugins/use-terms";
import {ODDS_TYPES} from "../odds/components/odds-consts";

export class ScoresListWidgetHeaderDesktopProps extends BaseProps {
  SmallCellContent: React.Component;
  MediumCellContent: React.Component;
  LargeCellContent: React.Component;
  controller: ModuleController;
  state: BaseMobxState;
  i18n: AppTerms;
  isLive: Boolean;
  showOdds: Boolean;
  containerClassName: String;
  selectedOddsType: ODDS_TYPES;
  onToggleOdds: Function;
  onOddsChange: Function;
}

export const ScoresHeader = UseTerms()((props: ScoresListWidgetHeaderDesktopProps) => {
  const subHeaderProps = {
    SmallCellContent: props.SmallCellContent,
    smallCellProps: props,
    LargeCellContent: props.LargeCellContent,
    largeCellProps: props,
    MediumCellContent: props.MediumCellContent,
    mediumCellProps: props,
  }

  return (
    <div className={'scores-header'}>
      <OptionsStripe {...subHeaderProps} />
    </div>
  );
});
